import { render } from "./SimpleQuote.vue?vue&type=template&id=495b4d73&scoped=true"
import script from "./SimpleQuote.vue?vue&type=script&lang=js"
export * from "./SimpleQuote.vue?vue&type=script&lang=js"

import "./SimpleQuote.vue?vue&type=style&index=0&id=495b4d73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495b4d73"]])

export default __exports__